import React from 'react'
import SEOHead from '../components/SEOHead'
import Tips from '../components/Tips'

const TipsPage: React.FC = () => {
  return (
    <div>
      <SEOHead
        title="Boat Trailer Maintenance Tips & Guides | Fast Boat Trailers"
        description="Expert boat trailer maintenance tips and guides from Fast Boat Trailers. Learn proper care for tires, bearings, brakes, lights, winterization, loading techniques, and troubleshooting common problems."
        keywords="boat trailer maintenance, trailer care tips, wheel bearing maintenance, trailer brake care, winterizing trailers, boat loading tips, trailer troubleshooting"
        ogTitle="Boat Trailer Maintenance Tips & Guides"
        ogDescription="Expert boat trailer maintenance tips covering tires, bearings, brakes, winterization, loading techniques, and troubleshooting."
        ogImage="/images/logos/fbt-logo-3-noborder.jpeg"
        canonical="https://fastboattrailers.com/tips"
      />
      <Tips />
    </div>
  )
}

export default TipsPage